'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { UpsellBannerRootContext } from './context/upsell-banner-root.context';
import { upsellBannerMediaRecipe } from './styles/upsell-banner-media.styles';
import type { UpsellBannerMediaPropsInterface } from './types/upsell-banner-media.types';

/**
 * @since 10.0.0
 */
export const UpsellBannerMedia = forwardRef<HTMLDivElement, UpsellBannerMediaPropsInterface>(
  (props: UpsellBannerMediaPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { tone } = useContext(UpsellBannerRootContext);
    const styles = css(upsellBannerMediaRecipe.raw({ tone }), cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="UpsellBanner.Media"
        className={cx('c11n', 'c11n_upsell-banner__media', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

UpsellBannerMedia.displayName = 'UpsellBanner.Media';
